import { useEffect, useState } from 'react'
import { Outlet } from 'react-router-dom'

import { SideBar } from './SideBar'
import { Header } from './Header'
import { useLayout } from '@hooks/useLayout'
import { useUser } from '@hooks/useUser'
import { useBudgetValidation } from '@hooks/useBudgetValidation'
import { BudgetValidationModal } from '@components/modals/BudgetValidationModal'

import * as S from './styles'

export const Layout = () => {
  const { setIsMenuOpen, isMenuCollapsedPersisted, setIsMenuCollapsedPersisted } = useLayout()
  const { userData, getUserPermissions } = useUser()
  const { shouldShowPopup, checkBudgetValidation, confirmPopup } = useBudgetValidation()

  const [sideBarCollapsed, setSideBarCollapsed] = useState(isMenuCollapsedPersisted || false)
  const [headerCollapsed, setHeaderCollapsed] = useState(false)

  const handleSetIsMenuOpen = (value: boolean) => {
    setIsMenuOpen(value)
    setSideBarCollapsed(value)
    setIsMenuCollapsedPersisted(value)
  }

  useEffect(() => {
    if (!userData?.user.id) return

    getUserPermissions(userData.user.id)
    // RC01: dispara no login novo e na sessão restaurada (auto-login) — único ponto pós-auth.
    checkBudgetValidation()
  }, [userData])

  return (
    <S.Container>
      <BudgetValidationModal open={shouldShowPopup} onConfirm={confirmPopup} />

      <SideBar sideBarCollapsed={sideBarCollapsed} setSideBarCollapsed={handleSetIsMenuOpen} />

      <S.Content sideBarCollapsed={sideBarCollapsed}>
        <Header
          sideBarCollapsed={sideBarCollapsed}
          setSideBarCollapsed={handleSetIsMenuOpen}
          headerCollapsed={headerCollapsed}
          setHeaderCollapsed={setHeaderCollapsed}
        />

        <S.MainContent headerCollapsed={headerCollapsed}>
          <Outlet />
          <S.Footer>
            <S.FooterMessage>
              © 2025 SmartOps. Todos os direitos são reservados. Criado por
              <S.BrandText>IDVLabs</S.BrandText>
            </S.FooterMessage>
          </S.Footer>
        </S.MainContent>
      </S.Content>
    </S.Container>
  )
}
